import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-busyable-button',
    templateUrl: './busyable-button.component.html',
    styleUrls: ['./busyable-button.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinner, MatIcon, FlexLayoutModule, MatButtonModule]
})
export class BusyableButtonComponent {
    @Input() type = 'submit';
    @Input() disabled = false;
    @Input() busy = false;
    @Input() text!: string;

    constructor() {}
}
